export default [
  {
    path: '/home',
    name: 'SchoolApply',
  },
  {
    path: '/schools',
    name: 'Schools',
  },
  {
    path: '/school',
    name: 'School',
  },
  {
    path: '/accounts',
    name: 'Accounts',
  },
  {
    path: '/account',
    name: 'Account',
  },
  {
    path: '/applications',
    name: 'Applications',
  },
  {
    path: '/notifications',
    name: 'Notifications',
  },
  {
    path: '/notification',
    name: 'Notification',
  },
  {
    path: "/school_apply_edit/:type",
    name: "SchoolApplyEdit"
  },
  {
    path: "/invoice_csv",
    name: "InvoiceCsv",
  },
];
